import React from 'react';
import { createPortal } from 'react-dom';
import { ErrorLoggerBoundary } from '../../../react-utils/ErrorBoundary';
import { getReactRendererFromState } from '../ReactRenderer';
import { WidgetDescriptor } from './WidgetDescriptor';
export class ReactWidgetDescriptor extends WidgetDescriptor {
    remove() {
        var _a;
        (_a = this.renderItem) === null || _a === void 0 ? void 0 : _a.remove();
        this.renderItem = undefined;
    }
    renderWidget() {
        var _a;
        this.renderItem = (_a = this.renderItem) !== null && _a !== void 0 ? _a : this.createRenderItem();
        this.renderItem.rerender();
        return this.getDomElem();
    }
    createRenderItem() {
        return getReactRendererFromState(this.view.state).createItem('widget', () => createPortal(React.createElement(ErrorLoggerBoundary, null, this.renderReactElement(this.view, this.getPos)), this.getDomElem()));
    }
}
